import {SettingsState} from './settings-types';
import {
    getContainerName,
    getShowDetails,
    getShowFieldSpecificSearch,
    getShowValidation,
    setContainerName,
    setShowDetails,
    setShowFieldSpecificSearch,
    setShowValidation,
} from './settings-localstorage-service';
import {SettingsAction} from './settings-actions';
import {produce} from 'immer';
import {showError} from '../../message-box/message-box-actions';

const initialState: SettingsState = {
    containerName: getContainerName() as string,
    technicalDetails: getShowDetails(),
    manualValidation: getShowValidation(),
    fieldSpecificSearch: getShowFieldSpecificSearch(),
    containers: {}
};

export function settingsReducer(state: SettingsState = initialState, action: SettingsAction): SettingsState {
    return produce(state, (draft: SettingsState) => {
        const savedContainerName = getContainerName();
        switch (action.type) {
            case 'SETTINGS_CHANGED': {
                draft.containerName = action.containerName;
                draft.technicalDetails = action.technicalDetails;
                draft.manualValidation = action.manualValidation;
                draft.fieldSpecificSearch = action.fieldSpecificSearch;
                setContainerName(action.containerName);
                setShowDetails(action.technicalDetails);
                setShowValidation(action.manualValidation);
                setShowFieldSpecificSearch(action.fieldSpecificSearch);
                break;
            }
            case 'CONTAINER_LOAD_FINISHED': {
                if (
                    savedContainerName == null ||
                    action.containers.find((e) => e.name === savedContainerName) === undefined
                ) {
                    setContainerName(action.defaultContainer);
                    draft.containerName = action.defaultContainer;
                    showError(
                        action.searchPageType,
                        'Container ' + savedContainerName + ' doesn\'t exist anymore.',
                        undefined,
                        4000
                    );
                }
                action.containers.forEach((container) => {
                    draft.containers[container.name] = container;
                });
                break;
            }
            case 'FIELD_SPECIFIC_SEARCH_SET': {
                draft.fieldSpecificSearch = action.fieldSpecificSearch;
                setShowFieldSpecificSearch(action.fieldSpecificSearch);
                break;
            }
        }
    });
}
